const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/pc'
  },
  {
    path: '/pc',
    name: 'pc-index',
    redirect: '/home',
    component: () => import('@/views/pc/index.vue'),
    children: [
      {
        path: '/home',
        name: 'pc-home',
        component: () => import('@/views/pc/home/index.vue')
      },
      {
        path: '/speaker',
        name: 'pc-speaker',
        component: () => import('@/views/pc/speaker/index.vue')
      },
      {
        path: '/news',
        name: 'pc-news',
        component: () => import('@/views/pc/news/index.vue')
      },
      {
        path: '/agenda',
        name: 'pc-agenda',
        component: () => import('@/views/pc/agenda/index.vue')
      },
      {
        path: '/session/:id',
        name: 'pc-session',
        component: () => import('@/views/pc/live/index.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/'
  }
]

export default routes
